import { render, staticRenderFns } from "./login.vue?vue&type=template&id=5485c7a4&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=5485c7a4&prod&scoped=true&lang=scss"
import style1 from "./login.vue?vue&type=style&index=1&id=5485c7a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485c7a4",
  null
  
)

export default component.exports